import AddIcon from '@mui/icons-material/Add';
import { Box, Button, Grid, TableContainer, Tooltip, Typography } from '@mui/material';
import { DataTable } from '../../components/core/DataTable/DataTable';
import { HeaderCell } from '../../components/core/DataTable/dataTable.types';
import { useTranslation } from '../../contexts/translation';
import { Shift } from '../../types/app/shifts.types';
interface Props {
  data: Shift[];
  shifts: Shift[];
  onAddShift: (id: number) => void;
}

export function ShiftToAssetAdd({ data, shifts, onAddShift }: Props) {
  const { t } = useTranslation();
  const headerCells: HeaderCell[] = [
    { title: t('page.shift.table-col-1'), key: 'name' },
    {
      title: t('page.shift.table-col-2'),
      key: 'start',
    },
    {
      title: t('page.shift.table-col-3'),
      key: 'end',
    },
    {
      title: ' ',
      key: '',
      cellRenderer: (params: any) => {
        return (
          <>
            <Tooltip title={t('general.action-buttons.add')}>
              <Button onClick={() => onAddShift(params.id)}>
                <AddIcon />
              </Button>
            </Tooltip>
          </>
        );
      },
    },
  ];

  // let filteredData = data ? data.filter((item: Shift) => !shifts.includes(item)) : [];

  const filteredArray = data
    ? data.filter(function (dataItm) {
        return (
          shifts.filter(function (currShifts) {
            return currShifts.id == dataItm.id;
          }).length == 0
        );
      })
    : null;

  return (
    <>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          border: '1px solid #000',
          maxWidth: '90%',
          boxShadow: 24,
          overFlow: 'auto',
          pt: 2,
          px: 0,
          pb: 3,
        }}
      >
        <Typography id="modal-modal-title" variant="h6" component="h2" px={4} mb={2}>
          {t('page.shift.modal-headline-add')}
        </Typography>
        <Grid item xs={12}>
          {filteredArray && (
            <TableContainer>
              <DataTable headerCells={headerCells} items={filteredArray} />
            </TableContainer>
          )}
        </Grid>
      </Box>
    </>
  );
}
